import { axios, AxiosResponse } from '~/modules'
import { IFetchNpsAppearanceNextDateParams, INpsResponse, INpsValues, IUserNPSAppearance } from '~/interfaces'
const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const sendNps = async (values: INpsValues): Promise<INpsResponse> => {
  const response = await axios.post(`${hstoryAPI}/nps`, values)
  const { data }: AxiosResponse<INpsResponse> = response
  return data
}

export const fetchNpsAppearanceNextDate = async (
  props: IFetchNpsAppearanceNextDateParams
): Promise<IUserNPSAppearance> => {
  const { pathParams } = props
  const response = await axios.get(`${hstoryAPI}/user-nps-appearance/${pathParams.userId}`)
  const { data }: AxiosResponse<IUserNPSAppearance> = response
  return data
}
